import { useMemo } from 'react';
import type { NavBarProps } from './nav-types';
import { useNavSources } from './useNavSources';
import { useNavStyle } from './useNavStyle';
import { NavBarCollapsed } from './NavBarCollapsed';
import { NavBarExpanded } from './NavBarExpanded';
import { SessionDock } from '../SessionDock';
import { useConfigureEntry } from '../ConfigureShell';

export function NavBar({ collapsed, onToggle, wsState, onCommandOpen }: NavBarProps) {
  const {
    allMainNavItems,
    visibleDrillGroups,
    mainDrillGroups,
    bottomDrillGroups,
    pluginBottomItems,
    takeoverBottomItems,
    labsItem,
    adminItem,
  } = useNavSources();
  const configureEntry = useConfigureEntry();
  const [navStyle] = useNavStyle();

  // The takeover doors (Automations, Connect) sit directly above the pinned
  // utility entries in the desktop sidebar footer. Labs is an icon-only
  // entry positioned next to Admin (shield).
  const bottomItems = useMemo(
    () => [
      ...takeoverBottomItems,
      labsItem,
      ...(adminItem ? [adminItem] : []),
      configureEntry,
      ...pluginBottomItems,
    ],
    [takeoverBottomItems, labsItem, adminItem, configureEntry, pluginBottomItems],
  );

  if (collapsed) {
    return (
      <NavBarCollapsed
        wsState={wsState}
        onCommandOpen={onCommandOpen}
        mainNavItems={allMainNavItems}
        mainDrillGroups={mainDrillGroups}
        bottomDrillGroups={bottomDrillGroups}
        pluginBottomItems={bottomItems}
      />
    );
  }

  // The sessions dock replaces the whole expanded sidebar: the session list
  // is the chrome. Collapsing still yields the icon rail above.
  if (navStyle === 'sessions') {
    return <SessionDock onToggle={onToggle} wsState={wsState} onCommandOpen={onCommandOpen} />;
  }

  return (
    <NavBarExpanded
      wsState={wsState}
      onCommandOpen={onCommandOpen}
      allMainNavItems={allMainNavItems}
      drillGroups={visibleDrillGroups}
      mainDrillGroups={mainDrillGroups}
      bottomDrillGroups={bottomDrillGroups}
      pluginBottomItems={bottomItems}
      navStyle={navStyle}
    />
  );
}
